module.exports = __webpack_public_path__ + "img/whatsapp.1dd15459.svg";